<template>
    <v-container>
      <!-- Datepicker para seleccionar la fecha de inicio -->
      <v-menu
        v-model="menuBegin"
        :close-on-content-click="false"
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-bind="attrs"
            v-on="on"
            :value="begin"
            label="Fecha de inicio"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker v-model="begin" @input="menuBegin = false"></v-date-picker>
      </v-menu>
  
      <!-- Datepicker para seleccionar la fecha de fin -->
      <v-menu
        v-model="menuEnd"
        :close-on-content-click="false"
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-bind="attrs"
            v-on="on"
            :value="end"
            label="Fecha de fin"
            prepend-icon="mdi-calendar"
            readonly
          ></v-text-field>
        </template>
        <v-date-picker v-model="end" @input="menuEnd = false"></v-date-picker>
      </v-menu>
  
      <v-btn @click="fetchData">Obtener datos</v-btn>
    </v-container>
  </template>
  
  <script>
  import { mapActions, mapState } from 'vuex';

  export default {
    data() {
      return {
        begin: null,  // Variable para la fecha de inicio
        end: null,    // Variable para la fecha de fin
        menuBegin: false,
        menuEnd: false,
      };
    },
    methods: {
        ...mapActions(['getAnalizerData']),
      async fetchData() {
        if (this.begin && this.end) {
          // Convertir las fechas a formato 'yyyyMMddTHHmmss' para la API
          const beginFormatted = this.formatDate(this.begin);
          const endFormatted = this.formatDate(this.end);
  
          // Llamar a la función de obtener datos
          const params = {
            var: 'CVMB150.VAE3',
            begin: beginFormatted,
            end: endFormatted,
          };
          const payload = {
            path:'get-xml',
            params: params
          }
  
          const data = await this.getAnalizerData(payload);
          const record = data.recordGroup.record;

          this.$emit('respuesta', record)
        //   console.log(data); // Aquí puedes manejar los datos recibidos
        }
      },
  
      // Función para formatear las fechas al formato 'yyyyMMddTHHmmss'
      formatDate(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        return `${day}${month}${year}T${hours}${minutes}${seconds}`;
      },
  
      // Función para obtener los datos desde la API
    //   async getAnalizerData(path, params) {
    //     const response = await axios.get(`${base_analizer_url}/${path}`, {
    //       headers: { authorization: `Bearer ${state.token}` },
    //       params,
    //     });
    //     return response.data;
    //   },
    },
  };
  </script>
  